import store from '@/store'
import { platform } from '@/utils/platform'
import { customAlphabet } from 'nanoid'
import { isLoginPWD, isURL } from '@/utils/validate'
import { getToken } from '@/utils/auth'

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

export function fen2Yuan(num) {
  return isNaN(num) ? '' : (num * 0.01).toFixed(2)
}

export function yuan2Fen(num) {
  if (isNaN(num)) {
    return ''
  }
  const amount = num.toString()
  const index = amount.indexOf('.')
  const arr = amount.split('.')
  let result = arr[0] * 100
  if (index > -1) {
    result += arr[1].split('').reduce((total, cur, index) => {
      if (index === 0) {
        return total + cur * 10
      } else {
        return total + cur * 1
      }
    }, 0)
  }
  return result
}

function suppleZero(num) {
  return num.toString().padStart(2, '0')
}

export function cutDownTimeArr2(ts = 0) {
  let day = Math.floor((ts / 1000 / 3600) / 24)
  let hour = Math.floor((ts / 1000 / 3600) % 24)
  let minute = Math.floor((ts / 1000 / 60) % 60)
  let second = Math.floor(ts / 1000 % 60)
  let milliseconds = (Math.floor(ts % 1000)).toString().replace(/\d{1}$/, '')
  return [suppleZero(day), suppleZero(hour), suppleZero(minute), suppleZero(second), milliseconds]
}

export function refreshTitle(title) {
  document.title = title
}

export function isPC() {
  const u = navigator.userAgent
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  let flag = true
  for (let i = 0; i < Agents.length; i++) {
    if (u.indexOf(Agents[i]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

/**
 * 返回最近几天内的起止时间
 * @param num 几天前
 * @param contain 去除不包含的天数
 * @returns {string[]}
 */
export function getBeforeTime(num = 7, contain = 24 * 3600 * 1000) {
  const date = new Date()
  const YYYY = date.getFullYear()
  const MM = (date.getMonth() + 1).toString().padStart(2, '0')
  const DD = (date.getDate()).toString().padStart(2, '0')
  const YYYYMMDD = platform.ios ? `${YYYY}/${MM}/${DD}` : `${YYYY}-${MM}-${DD}`
  const max = new Date(`${YYYYMMDD} 00:00:00`).getTime() - contain
  const min = max - (num - 1) * 24 * 3600 * 1000
  const minD = new Date(min)
  const maxD = new Date(max)
  const YYYY1 = minD.getFullYear()
  const MM1 = (minD.getMonth() + 1).toString().padStart(2, '0')
  const DD1 = (minD.getDate()).toString().padStart(2, '0')
  const YYYY2 = maxD.getFullYear()
  const MM2 = (maxD.getMonth() + 1).toString().padStart(2, '0')
  const DD2 = (maxD.getDate()).toString().padStart(2, '0')
  return [`${YYYY1}-${MM1}-${DD1} 00:00:00`, `${YYYY2}-${MM2}-${DD2} 23:59:59`]
}

export function value2Name(options = [], val) {
  if (!Array.isArray(options)) {
    return ''
  }

  const index = options.findIndex(item => item.value === val)
  if (index > -1) {
    return options[index].label || options[index].name || options[index].text
  }

  return ''
}

/**
 * 获取数组内指定项的属性值，如 options 为 [{label: '开启', value: 1, color: '#222'}]，val 为 1, key 为 color, 则返回值为 #222
 * @param options 原始数组，数组项必须为对象且有value属性
 * @param val value值
 * @param key 数组项的属性
 * @returns {any|string}
 */
export function value2Obj(options = [], val, key) {
  if (!Array.isArray(options)) {
    return ''
  }

  const index = options.findIndex(item => item.value === val)

  if (index > -1 && !key) {
    return options[index]
  }

  if (index > -1 && !!key && Object.prototype.hasOwnProperty.call(options[index], key)) {
    return options[index][key]
  }

  return ''
}

// 自动匹配用户的第一个页面
export function getFirstRoute(arr, route) {
  const routes = arr.filter(item => !item.disabled && !item.hidden && item.resType === 2)
  let children = []

  if (!routes.length) {
    return {}
  }

  for (let i = 0; i < routes.length; i++) {
    if (routes[i].children && routes[i].children.length) {
      children = routes[i].children
    } else {
      route = { ...routes[i] }
    }

    if (children.length || Object.keys(route).length) {
      break
    }
  }

  return Object.keys(route).length ? route : getFirstRoute(children, route)
}

// 随机生成密码 8~16 位
export function getRandomPw() {
  const str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const _nanoid = customAlphabet(str, 8)
  let value = _nanoid()

  while (!isLoginPWD(value)) {
    value = _nanoid()
  }

  return value
}

export const imgUrlPrefix = (url, pathRewrite = '/component/upload') => {
  if (Object.prototype.toString.call(url) !== '[object String]') {
    return ''
  }
  if (process.env.BUILD_ENV === undefined) {
    return `${process.env.API_DOMAIN}${pathRewrite}${url}`
  }
  return `${location.origin}${pathRewrite}${url}`
}

export const imgUrlRemovePrefix = (url, pathRewrite = '/component/upload') => {
  if (!url) {
    return url
  }
  if (process.env.BUILD_ENV === undefined) {
    return url.replace(`${process.env.API_DOMAIN}${pathRewrite}`, '')
  }
  return url.replace(`${location.origin}${pathRewrite}`, '')
}

//格式化代码函数,已经用原生方式写好了不需要改动,直接引用就好
export const formatJson = (json, options) => {
  var reg = null,
    formatted = '',
    pad = 0,
    PADDING = '    '
  options = options || {}
  options.newlineAfterColonIfBeforeBraceOrBracket = options.newlineAfterColonIfBeforeBraceOrBracket === true
  options.spaceAfterColon = !(options.spaceAfterColon === false)

  if (json === null || json === undefined) {
    return json
  }

  if (typeof json !== 'string') {
    json = JSON.stringify(json)
  } else {
    json = JSON.parse(json)
    json = JSON.stringify(json)
  }

  reg = /([\{\}])/g
  json = json.replace(reg, '\r\n$1\r\n')
  reg = /([\[\]])/g
  json = json.replace(reg, '\r\n$1\r\n')
  reg = /(\,)/g
  json = json.replace(reg, '$1\r\n')
  reg = /(\r\n\r\n)/g
  json = json.replace(reg, '\r\n')
  reg = /\r\n\,/g
  json = json.replace(reg, ',')
  if (!options.newlineAfterColonIfBeforeBraceOrBracket) {
    reg = /\:\r\n\{/g
    json = json.replace(reg, ':{')
    reg = /\:\r\n\[/g
    json = json.replace(reg, ':[')
  }
  if (options.spaceAfterColon) {
    reg = /\:/g
    json = json.replace(reg, ':')
  }
  (json.split('\r\n')).forEach(function (node, index) {
    var i = 0,
      indent = 0,
      padding = ''
    if (node.match(/\{$/) || node.match(/\[$/)) {
      indent = 1
    } else if (node.match(/\}/) || node.match(/\]/)) {
      if (pad !== 0) {
        pad -= 1
      }
    } else {
      indent = 0
    }
    for (i = 0; i < pad; i++) {
      padding += PADDING
    }
    formatted += padding + node + '\r\n'
    pad += indent
  })
  return formatted
}

// 区划懒加载点击圆点触发暂无数据页面问题隐藏
export const getCascaderDomhidden = () => {
  let dom = document.getElementsByClassName('el-scrollbar el-cascader-menu')
  dom.forEach((el, i) => {
    dom = document.getElementsByClassName('el-scrollbar el-cascader-menu')[i]
    dom.hidden = dom.innerText === '暂无数据' ? true : false
  })
  return dom
}

// 区划懒加载点击圆点触发暂无数据页面问题显示
export const getCascaderDomshow = () => {
  let dom = document.getElementsByClassName('el-scrollbar el-cascader-menu')
  dom.forEach((el, i) => {
    dom = document.getElementsByClassName('el-scrollbar el-cascader-menu')[i]
    dom.hidden = false
  })
  return dom
}

// 级联选择中：去除 children 的值为空数组场景
export function removeEmptyChildren(arr) {
  if (!Array.isArray(arr)) {
    return arr
  }

  arr.forEach(item => {
    if (item.children.length < 1) {
      delete item.children
    } else {
      removeEmptyChildren(item.children)
    }
  })

  return arr
}

// 阿拉伯数字千分位分割
export const toThousands = (num) => {
  if (num === null || num === undefined) {
    return num
  }

  if (Object.prototype.toString.call(num) === '[object Number]') {
    num = num.toString()
  }

  return num.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
}

// 大于1000的数字简写
export function formatNumber(val, digits = 2) {
  const si = [
    { value: 1, symbol: '' },
    { value: 1E3, symbol: 'K' },
    { value: 1E6, symbol: 'M' },
    { value: 1E9, symbol: 'G' },
    { value: 1E12, symbol: 'T' },
    { value: 1E15, symbol: 'P' },
    { value: 1E18, symbol: 'E' }
  ]
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/

  if (isNaN(val) || val === null) {
    return 0
  }

  let i
  for (i = si.length - 1; i > 0; i--) {
    if (val >= si[i].value) {
      break
    }
  }
  return (val / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol
}

/**
 * 参考浙里办对用户敏感数据处理：
 * 姓名（用户名）采用首字*+后面名字处理，如：张三，处理后显示为：*三；
 * */
export function noPassByName(str) {
  if (str === null || str === undefined) {
    return str
  }

  return '*' + str.toString().substring(1, str.length)
}

/**
 * 参考浙里办对用户敏感数据处理：
 * 联系方式：显示前三位和后四位，其他用*代替，如：18234567890，处理后显示为：182****7890；
 * */
export function noPassByMobile(str) {
  if (str === null || str === undefined) {
    return str
  }

  return str.toString().replace(/(\d{3})(.*)(\d{4})/, '$1****$3')
}

/**
 * 参考浙里办对用户敏感数据处理：
 * 身份证号：显示第一位和最后一位，其他用*代替。
 * */
export function noPassByIdCard(str) {
  if (str === null || str === undefined) {
    return str
  }

  return str.toString().replace(/(\w{1})(.*)(\w{1})/, '$1****************$3')
}

// 克隆
export const deepClone = function (origin) {
  if (origin === undefined) {
    return undefined
  }

  return JSON.parse(JSON.stringify(origin))
}

function clearString() {
  const args = new Array(...arguments)
  let string = args.shift()
  while (args.length) {
    string = string.split(args[0].str)[args[0].index]
    args.shift()
  }
  return string
}

export const getQueryString = (name) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|/#/|$)', 'g')
  const urls = window.location.href.split('?')
  let result = ''
  urls.forEach((url) => {
    const temp = url.match(reg)
    if (!result && temp && temp.length) {
      result = clearString(temp[0],
        { str: `${name}=`, index: 1 },
        { str: '/#/', index: 0 },
        { str: '&', index: 0 })
    }
  })
  return decodeURIComponent(result)
}

// 判断是不是对象类型的JSON数据
export const isObjectJson = (str) => {
  let res = false
  if (Object.prototype.toString.call(str) !== '[object String]' || !(/^\{.*\}$/g.test(str))) {
    return false
  }
  try {
    res = Object.prototype.toString.call(JSON.parse(str)) === '[object Object]'
  } catch (e) {
    res = false
  }

  return res
}

export const getTs = () => {
  return new Date().getTime()
}

/**
 * 获取 www.iconfont.cn 中组件化开发用图标
 * 需要去 iconfont 官网执行 getIconfont() ，获取到数据后直接覆盖 jw_project_template/htmldev/PC/v0/src/icons/iconfont.json
 * 路径：资源管理 - 我的项目 - 我参与的项目 - 组件化开发用图标
 * @returns {string}
 */
function getIconfont() {
  const iconfonts = document.querySelectorAll('.project-iconlist .block-icon-list .icon-code.icon-code-show')
  const res = []

  iconfonts.forEach(item => {
    const val = item.innerText.trim()
    if (/^icon-/.test(val)) {
      res.push(val)
    }
  })

  return JSON.stringify(res)
}

// 判断元素在可是区域
export const isInViewPort = (element) => {
  const viewWidth = window.innerWidth || document.documentElement.clientWidth
  const viewHeight = window.innerHeight || document.documentElement.clientHeight
  const { top, right, bottom, left } = element.getBoundingClientRect()

  return (top >= 0 && left >= 0 && right <= viewWidth && bottom <= viewHeight)
}

export const parsetURL = (val) => {
  if (!isURL(val)) {
    return {}
  }
  // 返回值：origin pathname
  return new URL(val)
}

/**
 * URL 去除 origin
 * @param url
 * @param condition 处理场景，默认为空：always-永久去除 ''-只在开发时去除
 * @returns {*|string|string}
 */
export const urlRemovePrefix = (url, condition = '') => {
  const { pathname } = parsetURL(url)

  if (condition === 'always') {
    return pathname || ''
  }

  if (process.env.BUILD_ENV === undefined) {
    return pathname || ''
  }
  return url
}

/**
 * 2023.09.06 13:49 文件类数据，后端返回数据格式为
 * 图片 {"serviceFileName": "", "prefixUrl": ""}
 * 附件之类需要实际文件名的 {"serviceFileName": "", "prefixUrl": "", "fileName": ""}
 * @param obj
 * @param condition 获取值的类型，默认为空：fileName-获取文件名 ''-获取文件地址
 * @returns {*|`${*}`|string|string}
 */
export const getMediaURL = (obj, condition = '') => {
  if (Object.prototype.toString.call(obj) !== '[object Object]') {
    return obj
  }

  if (!(Object.prototype.hasOwnProperty.call(obj, 'prefixUrl') && Object.prototype.hasOwnProperty.call(obj, 'serviceFileName'))) {
    return obj
  }

  if (condition === 'fileName') {
    return `${obj.fileName}` || ''
  }

  return `${obj.prefixUrl}${obj.serviceFileName}`
}

/**
 * 判断按钮是否有权限
 * @param key 按钮权限标识
 * @returns {boolean}
 */
export const hasBtnPermission = (key) => {
  if (Object.prototype.toString.call(key) !== '[object String]') {
    return false
  }
  return !(store.getters.buttonResKey.includes(key))
}


/**
 * 树形结构数据展平，变成一维数组
 * @param arr 原始数组
 * @param pid 父ID
 * @param res 结果
 * @returns {*[]}
 */
export function flattenArr(arr, pid, res = []) {
  if (!(Array.isArray(arr))) {
    return res
  }

  for (let item of arr) {
    res.push({
      ...item,
      children: null
    })

    if (Object.prototype.hasOwnProperty.call(item, 'children')) {
      flattenArr(item.children, item.id, res)
    }
  }


  return res
}

/**
 * 检测图片是否存在
 * @param url
 */
export const imgIsExist = function (url) {
  return new Promise((resolve) => {
    let img = new Image()
    img.onload = function () {
      if (this.complete === true) {
        resolve(true)
        img = null
      }
    }
    img.onerror = function () {
      resolve(false)
      img = null
    }
    img.src = url
  })
}

/**
 * 获取时间范围
 * @param start
 * @param end
 * @returns {string[]}
 */
export function getTimeRange(start = 0,end = 24) {
  let res = []

  for (let i = start; i < end; i++) {
    res.push(i)
  }

  return res.map(item => {
    const _start = item < 10 ? `0${item}` : item
    const _end = item + 1 < 10 ? `0${item + 1}` : item + 1
    return `${_start}:00-${_end}:00`
  })
}

export const initWebViewUrl = (path, query) => {
  let queryStr = `?token=${getToken()}&source=${process.env.PLATFORM_ENV}`
  if (Object.prototype.toString.call(query) === '[object Object]') {
    Object.keys(query).forEach((key, index) => {
      queryStr += `&${key}=${query[key]}`
    })
  }
  return `${process.env.VITE_APP_WEBVIEW_URL}${path}${queryStr}`
}

export const whiteList = {
  IMG: {
    extension: '.jpg,.png,.jpeg,.gif,.dng',
    api: '/api/park/cloud_file/upload/img'
  },
  DOC: {
    extension: '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt,.zip',
    api: '/api/park/cloud_file/upload/doc'
  },
  IMGORDOC: {
    extension: '.jpg,.png,.jpeg,.gif,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.zip',
    api: '/api/park/cloud_file/upload/imgOrDoc'
  },
  AUDIO: {
    extension: '.mp3,.wav,.wma,.aac',
    api: '/api/park/cloud_file/upload/audio'
  },
  VIDEO: {
    extension: '.mp4,.avi,.mpeg,.mov,.mkv',
    api: '/api/park/cloud_file/upload/video'
  }
}

export function validator({ files, extension = whiteList.IMG.extension, maxSize = undefined }) {
  const errMsg = []
  let checkFileType = false
  let checkFileSize = false

  const condition1 = Array.isArray(files) && files.length > 0 && files.map(file => Object.prototype.hasOwnProperty.call(file, 'path') && Object.prototype.hasOwnProperty.call(file, 'size'))
  const condition2 = Object.prototype.toString.call(extension) === '[object String]'

  if (!condition1 || !condition2) {
    return {
      errMsg,
      checkFileType,
      checkFileSize
    }
  }

  const list = files.map(item => item.path.split('/').pop())
  const fileSuffix = extension.split(',')
  // 校验文件类型
  checkFileType = list.every(fileName => {
    return fileSuffix.some(item => new RegExp(item, 'ig').test(fileName))
  })
  // 校验文件大小
  checkFileSize = Object.prototype.toString.call(maxSize) === '[object Number]' ? files.every(file => file.size <= maxSize * 1024 * 1024) : true

  if (!checkFileType) {
    errMsg.push(`只能上传 ${extension} 文件`)
  }

  if (!checkFileSize) {
    errMsg.push(`文件大小不能超过 ${maxSize}MB!`)
  }

  return {
    errMsg,
    checkFileType,
    checkFileSize
  }
}
